import { mergeAttributes } from '../../global/ui-helpers.js';
import type {
    FieldControl,
    FieldOption,
} from '../fieldset/ui-fieldset.type.js';
import type { ElementConfig } from '../ui-element.type.js';
import { UIAutocomplete } from './ui-autocomplete.js';

/**
 * Create an ElementConfig based on FieldControl
 * @param {FieldControl} control
 * @returns {ElementConfig}
 * @private
 */
export function fromControlConfig(control: FieldControl): ElementConfig {
    const data = (control.control ?? {}) as FieldControl;
    let options: Array<FieldOption> = [];
    if (data.options) {
        options = data.options.map((option: FieldOption) => {
            const additional: Record<string, string> = {};
            if (option.data) {
                for (const key in option.data) {
                    additional[`data-${key}`] = option.data[key];
                }
            }
            return {
                tagName: 'option',
                attributes: mergeAttributes(
                    {
                        value: option.value,
                        selected: option.value === data.value,
                    },
                    additional
                ),
                children: [option.content],
            };
        });
    }
    return {
        tagName: 'ui-autocomplete',
        attributes: control.attributes,
        children: [
            {
                tagName: 'input',
                attributes: mergeAttributes(
                    {
                        value: control.value ?? null,
                    },
                    control.control?.attributes ?? {}
                ),
            },
            {
                tagName: 'ui-datalist',
                children: options,
            },
        ],
    };
}

/**
 * Determines if the given layout is of type Account or Multipayment.
 *
 * @param {string} layout
 * @returns {boolean}
 */
export function isAccountTypeLayout(layout: string): boolean {
    return (
        layout === UIAutocomplete.Layout.Account ||
        layout === UIAutocomplete.Layout.Multipayment
    );
}
